module.exports = __webpack_public_path__ + "media/promo/panasonic/images/recbg-611c224f7cfca2cb1d6eff813b94fe43.png";